import React from "react";
import { IconButton } from "@mui/material";
import authService from "services/authService";
import { logout } from "redux/slices/accountSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { signOut } from "aws-amplify/auth";
import { ReactComponent as LogOutIcon } from "../../../static/svgs/LogOutIcon.svg";
import { ReactComponent as MailIcon } from "../../../static/svgs/MailIcon.svg";
import { removeDataFromLocalStorage } from "utils";

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { id, role } = useSelector((state: any) => state.account);

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMail = () => {
    const email = "SFFsupport@ets.org";
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;
  }

  const handleLogout = async () => {
    try {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      removeDataFromLocalStorage(`dropDownValue_${id}`)
      handleClose();
      try {
        await signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
      let resp = authService.logout();
      dispatch(logout());
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {role === 'ROLE_EDUCATOR' && (
        <IconButton
          onClick={handleMail}
          size="small"
          sx={{ pr: "24px", pb: 0 }}
        >
          <MailIcon />
        </IconButton>
      )}
      <IconButton
        onClick={handleLogout}
        size="small"
        sx={{ pr: "24px", pb: 0 }}
      >
        <LogOutIcon />
      </IconButton>
    </>
  );
};
export default UserMenu;
